exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".schedulecard[data-v-f0fb1f04]{margin-bottom:9px;padding:27px 18px}.schedulecard[data-v-f0fb1f04]:nth-child(2n){background-color:#f6f6f6}.schedulecard[data-v-f0fb1f04]:last-child{margin-bottom:0}.schedulecard .appText[data-v-f0fb1f04]{display:-ms-flexbox;display:flex;color:rgba(0,0,0,.85);font-family:Open Sans,sans-serif;font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f0fb1f04","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/catalog/card/components/tabs/schedule/components/schedulecard/ScheduleCard.vue
// module id = a5a7cbd3589fe2de92ac
// module chunks = 5